export default "__VITE_ASSET__Cfd9oquY__"